import React, { useCallback, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { isBlank } from "../../util/ext";

import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import Box from "@mui/material/Box";
import { Card, CardContent, CardHeader } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import OrganizationLogoDialog from "../edit/OrganizationLogoDialog";
import DeleteOrganizationLogoDialog from "../edit/DeleteOrganizationLogoDialog";
import FontAwesomeIcon from "../../components/FontAwesomeIcon";
import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";

const useStyles = makeStyles(theme => ({
  header: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  content: {
    paddingTop: 0,
  },

  logo: {
    maxHeight: 60,
    maxWidth: 200,
  },

  emptyLogo: {
    fontSize: 60,
  },
}));

const OrganizationLogoCard = ({ id, url }) => {
  const classes = useStyles();

  const [logoUrl, setLogoUrl] = useState(null);
  useEffect(() => {
    setLogoUrl(url);
  }, [url]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleEditClick = useCallback(() => {
    setEditDialogOpen(true);
  }, []);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const handleDeleteClick = useCallback(() => {
    setDeleteDialogOpen(true);
  }, []);

  const handleDelete = useCallback(() => {
    setDeleteDialogOpen(false);
    setLogoUrl(null);
  }, []);

  const handleDeleteCancel = useCallback(() => {
    setDeleteDialogOpen(false);
  }, []);

  const handleEditCancel = useCallback(() => {
    setEditDialogOpen(false);
  }, []);

  const handleEditSave = useCallback(data => {
    setLogoUrl(data.logoUrl);
    setEditDialogOpen(false);
  }, []);

  return (
    <Card raised elevation={4} style={{ height: "100%" }}>
      <CardHeader
        titleTypographyProps={{
          variant: "h6",
          color: "primary",
        }}
        title="Logo"
        action={
          <Box>
            <Tooltip title="Edit">
              <IconButton
                onClick={handleEditClick}
                aria-label="edit"
                size="large"
              >
                <EditIcon color="primary" fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                onClick={handleDeleteClick}
                aria-label="delete"
                size="large"
              >
                <FontAwesomeIcon icon={faTrashCan} />
              </IconButton>
            </Tooltip>
          </Box>
        }
        classes={{ root: classes.header }}
      />
      <CardContent classes={{ root: classes.content }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          {isBlank(logoUrl) ? (
            <PhotoOutlinedIcon className={classes.emptyLogo} />
          ) : (
            <img alt="Branding Logo" src={logoUrl} className={classes.logo} />
          )}
        </Box>
      </CardContent>
      {editDialogOpen && (
        <OrganizationLogoDialog
          open={editDialogOpen}
          organizationId={id}
          organizationLogoUrl={logoUrl}
          onCancel={handleEditCancel}
          onSave={handleEditSave}
        />
      )}
      {deleteDialogOpen && (
        <DeleteOrganizationLogoDialog
          open={deleteDialogOpen}
          organizationId={id}
          organizationLogoUrl={logoUrl}
          onCancel={handleDeleteCancel}
          onDelete={handleDelete}
        />
      )}
    </Card>
  );
};

export default OrganizationLogoCard;
